// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.riddle-card {
    padding: 5px 10px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    margin-bottom: 10px;
    overflow-y: hidden;
}

.riddle-page {
    padding: 5px 10px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    overflow-y: auto;
    height:100vh;
}

.riddle-items {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.item {
  padding: 10px;
  border-left: 3px solid #333;
  background: #f9f9f9;
  border-radius: 6px;
}

/* Button */
.riddles-btn {
    float:right;
   margin-top: 5px; 
  /* padding: 8px 14px; */
  border: none;
  background: #2563eb;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/riddle/riddle.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,WAAW;AACX;IACI,WAAW;GACZ,eAAe;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".riddle-card {\n    padding: 5px 10px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    margin-bottom: 10px;\n    overflow-y: hidden;\n}\n\n.riddle-page {\n    padding: 5px 10px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin-bottom: 10px;\n    overflow-y: auto;\n    height:100vh;\n}\n\n.riddle-items {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.item {\n  padding: 10px;\n  border-left: 3px solid #333;\n  background: #f9f9f9;\n  border-radius: 6px;\n}\n\n/* Button */\n.riddles-btn {\n    float:right;\n   margin-top: 5px; \n  /* padding: 8px 14px; */\n  border: none;\n  background: #2563eb;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
